import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import AILoadingButton from 'ai-components-ui-library/components/buttons/AILoadingButton';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { useContext, useEffect, useState } from 'react';
import { isFailed, isStarted, isSucceeded } from 'reporting-data/asyncData/AsyncData';
import { EnablementTrackingContext } from '../../../../../monitoring/EnablementTrackingContext';
import { getReportDatasetHasNotEnoughDataForAIInsights } from '../../../fullPage/report-ai-assistant-insights/utils';
import { useAIInsightsTracker } from '../useAIInsightsTracker';
import { useFetchReportAIAssistantInsightsWithV2 } from '../../../fullPage/report-ai-assistant-insights/useFetchReportAIAssistantInsights';
import { jsx as _jsx } from "react/jsx-runtime";
export function AISettingsPreviewButton({
  previewReport,
  reportResolve,
  setInsight,
  setInsightStatus
}) {
  const reportDatasetIsUndefinedOrHasFewerThan1DataPoint = getReportDatasetHasNotEnoughDataForAIInsights(previewReport, reportResolve);
  const [isDeferred, setDeferred] = useState(true);
  const [isRegenerate, setRegenerate] = useState(false);
  const {
    trackAIInsightsEvent
  } = useAIInsightsTracker(previewReport);
  const {
    enablementUsageTracker
  } = useContext(EnablementTrackingContext);
  const useInsightFetchHook = useFetchReportAIAssistantInsightsWithV2();
  const reportInsightsFetch = useInsightFetchHook({
    report: previewReport,
    reportResolve,
    isDeferred,
    numberOfInsights: 3
  });
  function onPreviewClick() {
    setInsight('');
    setDeferred(false);
    setRegenerate(true);
    trackAIInsightsEvent({
      action: 'previewSettings'
    });
  }
  useEffect(() => {
    const {
      status
    } = reportInsightsFetch;
    setInsightStatus(status);
    if (isSucceeded(reportInsightsFetch)) {
      var _reportInsightsFetch$;
      setInsight((_reportInsightsFetch$ = reportInsightsFetch.data.insights[0]) === null || _reportInsightsFetch$ === void 0 ? void 0 : _reportInsightsFetch$.value);
      setDeferred(true);
    } else if (isFailed(reportInsightsFetch)) {
      setDeferred(true);
    }
  }, [reportInsightsFetch, setInsight, setInsightStatus]);
  return /*#__PURE__*/_jsx(Tooltip, {
    title: I18n.text('reporting-enablement.platformReport.reportVisualizationInsights.emptyDataset'),
    disabled: !reportDatasetIsUndefinedOrHasFewerThan1DataPoint,
    children: /*#__PURE__*/_jsx(AILoadingButton, {
      use: "tertiary",
      size: "sm",
      onClick: onPreviewClick,
      loading: isStarted(reportInsightsFetch),
      disabled: reportDatasetIsUndefinedOrHasFewerThan1DataPoint,
      usageTracker: enablementUsageTracker,
      isRegenerate: isRegenerate,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "reporting-enablement.aiInsightsSettings.preview"
      })
    })
  });
}